import React, { useContext } from "react";
import { StaticImage }  from "gatsby-plugin-image";

import { Headline } from "../../../../components/Headline";
import { Button } from "../../../../components/Button";
import { Background } from "../../../../components/Background/Background";

import CameraComparisonContext from "../CameraComparisonContext";

import t from "../../../../lib/translate";

import * as styles from "./comparisonHeader.module.less";

const logo = "../../../../static/infratec-logo.svg";

export function ComparisonHeader() {
    const { active, cameraCount, toggleComparison, setSlideState } = useContext(CameraComparisonContext);

    return (
        <div className={styles.comparisonHeader}>
            <div className={styles.leftContent}>
                <StaticImage className={styles.logo} src={logo} alt="Logo" />
                <Headline
                    semanticOfHeadline="H4 Style"
                    headlineClass={styles.headline}
                >
                    {t("camera.compare.label")}
                </Headline>
                <span>{`(${cameraCount}/5)`}</span>
            </div>

            <Button
                type="secondary"
                icon={active ? "close" : "arrowRight"}
                iconPosition={active ? "right" : "left"}
                onClick={() => {toggleComparison(true); active ? setSlideState("down") : setSlideState("show")}}
                className={styles.closeButton}
            >
                {active
                    ? t("camera.compare.close.button")
                    : t("camera.compare.open.button")}
            </Button>
            <Background className={styles.headerBg} type="bg_a" />
        </div>
    );
}
